import {
  Directive,
  HostListener,
  HostBinding,
  ElementRef,
  Renderer2,
  OnInit,
  Input,
} from '@angular/core';


@Directive({
  selector: '[textareaAutoResize]',
  exportAs: 'textarea'
})
export class TextareaAutoResizeDirective implements OnInit {

  @Input() defineHeightOnInit: boolean = true;

  @HostBinding('class.autoresize') autoresize: boolean = true;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    if (this.defineHeightOnInit) { this.setHeight(); }
  }

  @HostListener('paste', ['$event'])
  onChange() {
    this.setHeight();
  }

  @HostListener('keydown', ['$event'])
  onKeydown() {
    this.setHeight();
  }

  @HostListener('focus', ['$event'])
  onFocus() {
    this.setHeight();
  }

  private setHeight() {
    setTimeout(() => {
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        'height',
        ''
      );
      if (!this.elementRef.nativeElement.scrollHeight) { return; }
      this.renderer.setStyle(
        this.elementRef.nativeElement,
        'height',
        this.elementRef.nativeElement.scrollHeight + 'px'
      );
    }, 0);
  }

}
